import actionTypes from '../constants/actionTypes';

export function logout() {
    return dispatch => {
        dispatch(logoutSeccess());
    }
}

function logoutSeccess() {
    return {
        type: actionTypes.LOGOUT_SUCCESS
    }
}

export function authFormChange(payload) {
    return {
        type: actionTypes.AUTH_FORM_CHANGE,
        payload
    }
}

function authFormSubmitSuccess(payload) {
    return {
        type: actionTypes.AUTH_FORM_SUBMIT_SUCCESS,
        payload
    }
}

function authFormSubmitError(payload) {
    return {
        type: actionTypes.AUTH_FORM_SUBMIT_ERROR,
        payload
    }
}

function authFormSubmitStart() {
    return {
        type: actionTypes.AUTH_FORM_SUBMIT_START
    }
}

function loginError(payload) {
    return {
        type: actionTypes.LOGIN_ERROR,
        payload
    }
}

function loginSuccess(payload) {
    return {
        type: actionTypes.LOGIN_SUCCESS,
        payload
    }
}

function loginStart() {
    return {
        type: actionTypes.LOGIN_START
    }
}

function authCheckStart() {
    return {
        type: actionTypes.AUTH_CHECK_START
    }
}

function authCheckSuccess() {
    return {
        type: actionTypes.AUTH_CHECK_SUCCESS
    }
}

function authCheckError(payload) {
    return {
        type: actionTypes.AUTH_CHECK_ERROR,
        payload
    }
}

export function authCheck() {
    var token = localStorage.getItem('token') || null;

    return dispatch => {
        dispatch(authCheckStart());

        if (!token)
            dispatch(logoutUser());

        return fetch(`${process.env.REACT_APP_SERVICE_KEYS_CLIENT_API_URL}/user/auth_check`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            mode: 'cors'
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                switch (response.status) {
                    case 401:
                        dispatch(logoutUser());
                    default:
                        throw new Error(response.statusText);
                }
            })
            .then((data) => {
                dispatch(authCheckSuccess());
            })
            .catch((error) => {
                dispatch(authCheckError(error.message));
            })
    }
}

export function login(key) {
    return dispatch => {
        return fetch(`${process.env.REACT_APP_SERVICE_KEYS_CLIENT_API_URL}/user/login/` + key, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            mode: 'cors'
        })
            .then((response) => {
                if (!response.ok) {
                    dispatch(loginError(response.statusText));
                    localStorage.setItem('email', '');
                    localStorage.setItem('token', '');
                    localStorage.setItem('id', '');
                    throw Error(response.statusText);
                } else {
                    return response.json();
                }
            })
            .then((data) => {
                localStorage.setItem('email', data.data.email);
                localStorage.setItem('token', data.data.tokenID);
                localStorage.setItem('id', data.data.id);
                dispatch(loginSuccess(data.data.email));
            })
            .catch((e) => console.log(e));
    }
}

export function loginB24(payload) {
    return dispatch => {
        dispatch(loginStart());
        return fetch(`${process.env.REACT_APP_SERVICE_KEYS_CLIENT_API_URL}/user/login`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            mode: 'cors',
            body: JSON.stringify(payload)
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                localStorage.setItem('email', '');
                localStorage.setItem('token', '');
                localStorage.setItem('id', '');
                localStorage.setItem('admin', '');

                switch (response.status) {
                    case 401:
                        throw new Error('Ошибка авторизации');
                    case 403:
                        throw new Error('Недостаточно прав');
                    default:
                        throw new Error(response.statusText);
                }
            })
            .then((data) => {
                localStorage.setItem('email', data.data.email);
                localStorage.setItem('token', data.data.tokenID);
                localStorage.setItem('id', data.data.id);
                localStorage.setItem('admin', data.data.admin);
                dispatch(loginSuccess({ email: data.data.email, admin: data.data.admin }));
            })
            .catch((error) => {
                dispatch(loginError(error.message));
            })
    }
}

export function submitAuth(data) {
    return dispatch => {

        dispatch(authFormSubmitStart());

        return fetch(`${process.env.REACT_APP_SERVICE_KEYS_CLIENT_API_URL}/user/mailauth`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            mode: 'cors'
        })
            .then((response) => {
                if (!response.ok) {
                    dispatch(authFormSubmitError(response.statusText));
                    throw Error(response.statusText);
                } else {
                    return response.json();
                }
            })
            .then((data) => {
                dispatch(authFormSubmitSuccess(data.data));
            })
            .catch((e) => console.log(e));
    }
}

export function logoutUser() {
    return dispatch => {
        localStorage.removeItem('username');
        localStorage.removeItem('token');
        localStorage.removeItem('id');
        localStorage.removeItem('email');
        localStorage.removeItem('admin');
        dispatch(logout());
        dispatch(authFormChange({}));
    }
}


// WEBPACK FOOTER //
// ./src/actions/authActions.js